// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type MediaPaths = paths;
export const MEDIA_SERVICE = "media" as const;

/** Typed openapi-fetch client for the media service (schema `media`). */
export function createMediaClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("media", options);
}

export type MediaClient = ReturnType<typeof createMediaClient>;
